// Note: Possibly temporary until we can hook up with CPS for a service
const silhouettes = [
  {
    code: '105',
    description: 'SHORT',
    abbreviation: 'SHORT',
    divisionCodes: ['10']
  },
  {
    code: '108',
    description: 'PANT - KNEE LENGTH',
    abbreviation: 'PNTKNLNGTH',
    divisionCodes: ['10']
  },
  {
    code: '110',
    description: 'PANT',
    abbreviation: 'PANT',
    divisionCodes: ['10']
  },
  {
    code: '115',
    description: 'TIGHTS',
    abbreviation: 'TIGHT',
    divisionCodes: ['10']
  },
  {
    code: '116',
    description: '3/4 LENGTH TIGHT',
    abbreviation: '3/4 TIGHT',
    divisionCodes: ['10']
  },
  {
    code: '118',
    description: 'SHORT - 2 IN 1',
    abbreviation: 'SRT-2 IN 1',
    divisionCodes: ['10']
  },
  {
    code: '120',
    description: 'BRIEF',
    abbreviation: 'BRIEF',
    divisionCodes: ['10']
  },
  {
    code: '121',
    description: 'BIKINI BOTTOM',
    abbreviation: 'BIKINI BTM',
    divisionCodes: ['10']
  },
  {
    code: '125',
    description: 'SKIRT',
    abbreviation: 'SKIRT',
    divisionCodes: ['10']
  },
  {
    code: '131',
    description: 'THONG',
    abbreviation: 'THONG',
    divisionCodes: ['10']
  },
  {
    code: '132',
    description: 'HIPSTER',
    abbreviation: 'HIPSTER',
    divisionCodes: ['10']
  },
  {
    code: '133',
    description: 'BOYSHORT',
    abbreviation: 'BOYSHORT',
    divisionCodes: ['10']
  },
  {
    code: '140',
    description: 'WARM UP',
    abbreviation: 'WARMUP',
    divisionCodes: ['10']
  },
  {
    code: '145',
    description: 'JUMP SUIT',
    abbreviation: 'JUMPSUIT',
    divisionCodes: ['10']
  },
  {
    code: '162',
    description: 'TIGHT - KNEE LENGTH',
    abbreviation: 'TGTKNEELNG',
    divisionCodes: ['10']
  },
  {
    code: '165',
    description: 'UNITARD/LEOTARD',
    abbreviation: 'UNITARD',
    divisionCodes: ['10']
  },
  {
    code: '166',
    description: 'LNG SLV SHORT LEG SUIT',
    abbreviation: 'LGSL SHL S',
    divisionCodes: ['10']
  },
  {
    code: '167',
    description: 'HOODED LNG SLV FULL SUIT',
    abbreviation: 'HD LSLV FS',
    divisionCodes: ['10']
  },
  {
    code: '168',
    description: 'LONG SLEEVE FULL SUIT',
    abbreviation: 'LSLV FL S',
    divisionCodes: ['10']
  },
  {
    code: '169',
    description: 'SHORT SLEEVE FULL SUIT',
    abbreviation: 'SSLV FL S',
    divisionCodes: ['10']
  },
  {
    code: '170',
    description: 'SUIT',
    abbreviation: 'SUIT',
    divisionCodes: ['10']
  },
  {
    code: '171',
    description: 'SHORT SLV SHORT LEG SUIT',
    abbreviation: 'SHRTSLVLEG',
    divisionCodes: ['10']
  },
  {
    code: '172',
    description: 'SET - ACCESSORIES',
    abbreviation: 'ST-ACCESS',
    divisionCodes: ['10']
  },
  {
    code: '175',
    description: 'TUBE SOCK',
    abbreviation: 'TUBE SOCK',
    divisionCodes: ['10']
  },
  {
    code: '180',
    description: 'ONE QUARTER SOCK',
    abbreviation: '1/4 SOCK',
    divisionCodes: ['10', '30']
  },
  {
    code: '185',
    description: 'CREW SOCK',
    abbreviation: 'CREW SOCK',
    divisionCodes: ['10', '30']
  },
  {
    code: '195',
    description: '3/4 LENGTH SOCK',
    abbreviation: '3/4 SOCK',
    divisionCodes: ['10', '30']
  },
  {
    code: '200',
    description: 'KNEE HIGH SOCK',
    abbreviation: 'KNEE HI SK',
    divisionCodes: ['30', '10']
  },
  {
    code: '205',
    description: 'BAG',
    abbreviation: 'BAG',
    divisionCodes: ['30', '10']
  },
  {
    code: '210',
    description: 'CAP/HAT/VISOR',
    abbreviation: 'CAP/HAT/VI',
    divisionCodes: ['10']
  },
  {
    code: '212',
    description: 'HEADWEAR - OTHER',
    abbreviation: 'HEADWROTHR',
    divisionCodes: ['10']
  },
  {
    code: '215',
    description: 'SWEATBAND - HEAD',
    abbreviation: 'HEADBAND',
    divisionCodes: ['30', '10']
  },
  {
    code: '218',
    description: 'HEADWEAR - BEANIE',
    abbreviation: 'HEADWRBNIE',
    divisionCodes: ['10']
  },
  {
    code: '220',
    description: 'GLOVES',
    abbreviation: 'GLOVES',
    divisionCodes: ['30', '10']
  },
  {
    code: '225',
    description: 'TEMPLE-LESS',
    abbreviation: 'TEMPLELESS',
    divisionCodes: ['30']
  },
  {
    code: '235',
    description: 'FOLDING TEMPLES',
    abbreviation: 'FOLDTEMPLE',
    divisionCodes: ['30']
  },
  {
    code: '240',
    description: 'OTHER MISCELLANEOUS',
    abbreviation: 'OTHR MISC',
    divisionCodes: ['10']
  },
  {
    code: '245',
    description: 'SWEATBAND - ARM',
    abbreviation: 'ARMBAND',
    divisionCodes: ['30', '10']
  },
  {
    code: '246',
    description: 'WRISTBAND',
    abbreviation: 'WRISTBAND',
    divisionCodes: ['30']
  },
  {
    code: '255',
    description: 'OTHER ACCESSORIES',
    abbreviation: 'OTHR ACCES',
    divisionCodes: ['30', '10']
  },
  {
    code: '258',
    description: 'SLEEVE',
    abbreviation: 'SLEEVE',
    divisionCodes: ['30', '10']
  },
  {
    code: '265',
    description: 'ONE PIECE',
    abbreviation: 'ONE PIECE',
    divisionCodes: ['10']
  },
  {
    code: '272',
    description: 'SWIMSUIT',
    abbreviation: 'SWIMSUIT',
    divisionCodes: ['10']
  },
  {
    code: '275',
    description: '3/4 LENGTH PANT',
    abbreviation: '3/4 PANT',
    divisionCodes: ['10']
  },
  {
    code: '285',
    description: 'NO SHOW SOCK',
    abbreviation: 'NOSHOWSOCK',
    divisionCodes: ['10', '30']
  },
  {
    code: '290',
    description: 'LOW CUT SOCK',
    abbreviation: 'LOWCUTSOCK',
    divisionCodes: ['10', '30']
  },
  {
    code: '295',
    description: 'HI QUARTER SOCK',
    abbreviation: 'HIATRSOCK',
    divisionCodes: ['10', '30']
  },
  {
    code: '300',
    description: 'DUFFEL GRIP DRUM',
    abbreviation: 'DUFFEL',
    divisionCodes: ['10', '30']
  },
  {
    code: '303',
    description: 'BAG - GOLF CLUB CARRY',
    abbreviation: 'BGOLFCLCRY',
    divisionCodes: ['30']
  },
  {
    code: '305',
    description: 'BACKPACK',
    abbreviation: 'BKPACK',
    divisionCodes: ['10', '30']
  },
  {
    code: '308',
    description: 'BAG - GOLF CLUB CART',
    abbreviation: 'BGOLFCLBCT',
    divisionCodes: ['30']
  },
  {
    code: '312',
    description: 'BAG - SHOE',
    abbreviation: 'BAG - SHOE',
    divisionCodes: ['10', '30']
  },
  {
    code: '315',
    description: 'GYM SACK',
    abbreviation: 'GYM SAK',
    divisionCodes: ['10', '30']
  },
  {
    code: '320',
    description: 'TOTE',
    abbreviation: 'TOTE',
    divisionCodes: ['30', '10']
  },
  {
    code: '323',
    description: 'BAG - WAISTPACK',
    abbreviation: 'BGWAISTPK',
    divisionCodes: ['10', '30']
  },
  {
    code: '325',
    description: 'BAG ACCESSORIES',
    abbreviation: 'BAGACC',
    divisionCodes: ['30']
  },
  {
    code: '742',
    description: 'HARDSHELL LUGGAGE',
    abbreviation: 'HRDLUG',
    divisionCodes: ['10', '30']
  },
  {
    code: '743',
    description: 'SOFTSHELL LUGGAGE',
    abbreviation: 'SFTLUG',
    divisionCodes: ['10', '30']
  },
  {
    code: '340',
    description: 'MESSENGER BAGS',
    abbreviation: 'MESSENGER',
    divisionCodes: ['10', '30']
  },
  {
    code: '345',
    description: 'SMALL ITEMS WAISTPACKS',
    abbreviation: 'SITM WSTPK',
    divisionCodes: ['30', '10']
  },
  {
    code: '350',
    description: 'HAND SHOULDER BAGS',
    abbreviation: 'HAND SHLDR',
    divisionCodes: ['30', '10']
  },
  {
    code: '355',
    description: 'DRIVER',
    abbreviation: 'DRIVER',
    divisionCodes: ['30']
  },
  {
    code: '358',
    description: 'CLUB - COMPONENT HEAD',
    abbreviation: 'CLCMPHEAD',
    divisionCodes: ['30']
  },
  {
    code: '360',
    description: 'FAIRWAY WOOD',
    abbreviation: 'FWY WOOD',
    divisionCodes: ['30']
  },
  {
    code: '365',
    description: 'HYBRID',
    abbreviation: 'HYBRID',
    divisionCodes: ['30']
  },
  {
    code: '370',
    description: 'IRON',
    abbreviation: 'IRON',
    divisionCodes: ['30']
  },
  {
    code: '375',
    description: 'WEDGE',
    abbreviation: 'WEDGE',
    divisionCodes: ['30']
  },
  {
    code: '380',
    description: 'PUTTER',
    abbreviation: 'PUTTER',
    divisionCodes: ['30']
  },
  {
    code: '385',
    description: 'DRIVER HEAD',
    abbreviation: 'DRIVER HD',
    divisionCodes: ['30']
  },
  {
    code: '390',
    description: 'FAIRWAY WOOD HEAD',
    abbreviation: 'FW WOOD HD',
    divisionCodes: ['30']
  },
  {
    code: '395',
    description: 'HYBRID HEAD',
    abbreviation: 'HYBRID HD',
    divisionCodes: ['30']
  },
  {
    code: '400',
    description: 'IRON HEAD',
    abbreviation: 'IRON HEAD',
    divisionCodes: ['30']
  },
  {
    code: '405',
    description: 'WEDGE HEAD',
    abbreviation: 'WEDGE HD',
    divisionCodes: ['30']
  },
  {
    code: '410',
    description: 'SHAFT',
    abbreviation: 'SHAFT',
    divisionCodes: ['30']
  },
  {
    code: '415',
    description: 'GRIP',
    abbreviation: 'GRIP',
    divisionCodes: ['30']
  },
  {
    code: '420',
    description: 'CLUB ACCESSORIES',
    abbreviation: 'CLUB ACESS',
    divisionCodes: ['30']
  },
  {
    code: '425',
    description: 'HOODED JACKET',
    abbreviation: 'HODED JCKT',
    divisionCodes: ['10']
  },
  {
    code: '430',
    description: 'HOODED LONG SLEEVE TOP',
    abbreviation: 'HD LG SLTP',
    divisionCodes: ['10']
  },
  {
    code: '435',
    description: 'HOODED SHORT SLEEVE TOP',
    abbreviation: 'HD ST SLTP',
    divisionCodes: ['10']
  },
  {
    code: '436',
    description: 'HOODED FULL ZIP LS TOP',
    abbreviation: 'HD FZ LS T',
    divisionCodes: ['10']
  },
  {
    code: '440',
    description: 'MINIBALL',
    abbreviation: 'MINIBALL',
    divisionCodes: ['30']
  },
  {
    code: '445',
    description: 'SET',
    abbreviation: 'SET',
    divisionCodes: ['10']
  },
  {
    code: '450',
    description: 'SHINGUARD',
    abbreviation: 'SHINGUARD',
    divisionCodes: ['30']
  },
  {
    code: '452',
    description: 'PROTECTIVE GEAR - OTHER',
    abbreviation: 'PROTGROTH',
    divisionCodes: ['30']
  },
  {
    code: '458',
    description: 'SLEEVE - ANKLE',
    abbreviation: 'SLV-ANKLE',
    divisionCodes: ['30']
  },
  {
    code: '462',
    description: 'SLEEVE - OTC',
    abbreviation: 'SLEEVE-OTC',
    divisionCodes: ['30']
  },
  {
    code: '475',
    description: 'BELT',
    abbreviation: 'BELT',
    divisionCodes: ['10']
  },
  {
    code: '485',
    description: 'SCARF',
    abbreviation: 'SCARF',
    divisionCodes: ['10', '30']
  },
  {
    code: '495',
    description: 'ROUND BALL',
    abbreviation: 'ROUND BALL',
    divisionCodes: ['30']
  },
  {
    code: '500',
    description: 'CLUB BAG',
    abbreviation: 'CLUB BAG',
    divisionCodes: ['10', '30']
  },
  {
    code: '505',
    description: 'TRACK JACKET',
    abbreviation: 'TRCK JCKET',
    divisionCodes: ['10']
  },
  {
    code: '510',
    description: 'BAT',
    abbreviation: 'BAT',
    divisionCodes: ['30']
  },
  {
    code: '520',
    description: 'FIELDING GLOVE',
    abbreviation: 'FIELD GLVE',
    divisionCodes: ['30']
  },
  {
    code: '525',
    description: 'GOALIE GLOVE',
    abbreviation: 'GOALIE GLV',
    divisionCodes: ['30']
  },
  {
    code: '530',
    description: 'ELLIPTICAL BALL',
    abbreviation: 'ELPTCLBALL',
    divisionCodes: ['30']
  },
  {
    code: '535',
    description: 'ELLIPTICAL MINIBALL',
    abbreviation: 'ELPTMINBAL',
    divisionCodes: ['30']
  },
  {
    code: '540',
    description: 'TWO PIECE SET',
    abbreviation: 'TWO PC SET',
    divisionCodes: ['10']
  },
  {
    code: '545',
    description: 'VARSITY JACKET',
    abbreviation: 'VRSTYJCKET',
    divisionCodes: ['10']
  },
  {
    code: '546',
    description: 'DIMPLED BALL',
    abbreviation: 'DIMPLED BL',
    divisionCodes: ['30']
  },
  {
    code: '547',
    description: 'TOP - LONG SLV',
    abbreviation: 'TPLNGSLV',
    divisionCodes: ['10']
  },
  {
    code: '548',
    description: 'LEG - SLEEVE',
    abbreviation: 'LEGSLEEVE',
    divisionCodes: ['10']
  },
  {
    code: '549',
    description: 'HOODED SLEEVELESS TOP',
    abbreviation: 'HDSLVSSTP',
    divisionCodes: ['10']
  },
  {
    code: '042',
    description: 'TEE - 3/4 SLEEVE',
    abbreviation: 'TEE-3/4 SL',
    divisionCodes: ['10']
  },
  {
    code: '037',
    description: 'SLEEVELESS POLO',
    abbreviation: 'SLVLS POLO',
    divisionCodes: ['10']
  },
  {
    code: '015',
    description: 'THREE QUARTER HIGH',
    abbreviation: '3/4 HI',
    divisionCodes: ['20']
  },
  {
    code: '005',
    description: 'NOT APPLICABLE',
    abbreviation: 'N/A',
    divisionCodes: ['20', '40', '30', '10']
  },
  {
    code: '080',
    description: 'JACKET',
    abbreviation: 'JACKET',
    divisionCodes: ['10']
  },
  {
    code: '070',
    description: 'SHIMMEL/CROP',
    abbreviation: 'SHIMMEL',
    divisionCodes: ['10']
  },
  {
    code: '055',
    description: 'SHORT SLEEVE TOP',
    abbreviation: 'SHSLTOP',
    divisionCodes: ['10']
  },
  {
    code: '065',
    description: 'SLEEVELESS TOP',
    abbreviation: 'LESSTOP',
    divisionCodes: ['10']
  },
  {
    code: '045',
    description: 'AIRBORN TOP',
    abbreviation: 'AIRBORN',
    divisionCodes: ['10']
  },
  {
    code: '060',
    description: 'LONG SLEEVE TOP',
    abbreviation: 'LGSLTOP',
    divisionCodes: ['10']
  },
  {
    code: '040',
    description: '3/4 SLEEVE',
    abbreviation: '3/4 SLEEVE',
    divisionCodes: ['10']
  },
  {
    code: '025',
    description: 'SHORT SLEEVE POLO',
    abbreviation: 'S/S POLO',
    divisionCodes: ['10']
  },
  {
    code: '036',
    description: 'LONG SLEEVE POLO',
    abbreviation: 'L/S POLO',
    divisionCodes: ['10']
  },
  {
    code: '010',
    description: 'LOW TOP',
    abbreviation: 'LOWTOP',
    divisionCodes: ['20']
  },
  {
    code: '020',
    description: 'HIGH TOP',
    abbreviation: 'HITOP',
    divisionCodes: ['20']
  },
  {
    code: '090',
    description: 'LONG SLEEVE T-SHIRT',
    abbreviation: 'L/S TSHIRT',
    divisionCodes: ['10']
  },
  {
    code: '085',
    description: 'VEST',
    abbreviation: 'VEST',
    divisionCodes: ['10']
  },
  {
    code: '075',
    description: 'TANK TOP/SINGLET',
    abbreviation: 'TKTOP/SING',
    divisionCodes: ['10']
  },
  {
    code: '050',
    description: 'SHORT SLEEVE T-SHIRT',
    abbreviation: 'S/S TSHIRT',
    divisionCodes: ['10']
  },
  {
    code: '035',
    description: 'SLEEVELESS T SHIRT',
    abbreviation: 'SLVLELSTEE',
    divisionCodes: ['10']
  },
  {
    code: '030',
    description: 'BRA',
    abbreviation: 'BRA',
    divisionCodes: ['10']
  },
  {
    code: '076',
    description: 'BIKINI TOP',
    abbreviation: 'BIKINI TOP',
    divisionCodes: ['10']
  },
  {
    code: '024',
    description: 'SOCK BOOT',
    abbreviation: 'SOCK BOOT',
    divisionCodes: ['10']
  },
  {
    code: '610',
    description: 'FULL LENGTH PANT',
    abbreviation: 'FLLPNT',
    divisionCodes: ['10']
  },
  {
    code: '615',
    description: 'ANKLE LENGTH PANT',
    abbreviation: 'AKLPNT',
    divisionCodes: ['10']
  },
  {
    code: '620',
    description: 'MID CALF LENGTH PANT',
    abbreviation: 'MCFPNT',
    divisionCodes: ['10']
  },
  {
    code: '625',
    description: 'UPPER CALF LENGTH PANT',
    abbreviation: 'UCFPNT',
    divisionCodes: ['10']
  },
  {
    code: '630',
    description: 'KNEE LENGTH SHORT',
    abbreviation: 'KNEE LENGTH SHORT',
    divisionCodes: ['10']
  },
  {
    code: '635',
    description: 'MID THIGH LENGTH SHORT',
    abbreviation: 'MTHPNT',
    divisionCodes: ['10']
  },
  {
    code: '640',
    description: 'UPPER THIGH LENGTH SHORT',
    abbreviation: 'UTHPNT',
    divisionCodes: ['10']
  },
  {
    code: '645',
    description: 'FULL LENGTH SKIRT',
    abbreviation: 'FLLSKT',
    divisionCodes: ['10']
  },
  {
    code: '650',
    description: 'MID CALF LENGTH SKIRT',
    abbreviation: 'MCFSKT',
    divisionCodes: ['10']
  },
  {
    code: '655',
    description: 'UPPER CALF LENGTH SKIRT',
    abbreviation: 'UPPER CALF LENGTH SKIRT',
    divisionCodes: ['10']
  },
  {
    code: '660',
    description: 'KNEE LENGTH SKIRT',
    abbreviation: 'KNEE LENGTH SKIRT',
    divisionCodes: ['10']
  },
  {
    code: '665',
    description: 'MID THIGH LENGTH SKIRT',
    abbreviation: 'MTHSKT',
    divisionCodes: ['10']
  },
  {
    code: '670',
    description: 'UPPER THIGH LENGTH SKIRT',
    abbreviation: 'UTHSKT',
    divisionCodes: ['10']
  },
  {
    code: '738',
    description: 'THIGH LENGTH DRESS',
    abbreviation: 'THLGDR',
    divisionCodes: ['10']
  },
  {
    code: '739',
    description: 'KNEE LENGTH DRESS',
    abbreviation: 'KNLGDR',
    divisionCodes: ['10']
  },
  {
    code: '740',
    description: 'CALF LENGTH DRESS',
    abbreviation: 'CFLGDR',
    divisionCodes: ['10']
  },
  {
    code: '741',
    description: 'FULL LENGTH DRESS',
    abbreviation: 'FLLGDR',
    divisionCodes: ['10']
  }
];

const silhouetteTypes = [
  {
    code: '10',
    description: 'TOP',
    abbreviation: 'TOP',
    divisionCodes: ['10']
  },
  {
    code: '12',
    description: 'BALL',
    abbreviation: 'BALL',
    divisionCodes: ['30']
  },
  {
    code: '13',
    description: 'KIT',
    abbreviation: 'KIT',
    divisionCodes: ['10']
  },
  {
    code: '14',
    description: 'PROTECTIVE GEAR',
    abbreviation: 'PRGEAR',
    divisionCodes: ['30']
  },
  {
    code: '15',
    description: 'BAT',
    abbreviation: 'BAT',
    divisionCodes: ['30']
  },
  {
    code: '20',
    description: 'BOTTOM',
    abbreviation: 'BOTTOM',
    divisionCodes: ['10']
  },
  {
    code: '30',
    description: 'SET/WARMUP',
    abbreviation: 'WARMUP',
    divisionCodes: ['10']
  },
  {
    code: '40',
    description: 'ONE PIECE SUIT',
    abbreviation: 'SUIT',
    divisionCodes: ['10']
  },
  {
    code: '41',
    description: 'WETSUIT',
    abbreviation: 'WETSUT',
    divisionCodes: ['10']
  },
  {
    code: '50',
    description: 'SOCK',
    abbreviation: 'SOCK',
    divisionCodes: ['10', '30']
  },
  {
    code: '60',
    description: 'BAG',
    abbreviation: 'BAG',
    divisionCodes: ['30', '10']
  },
  {
    code: '70',
    description: 'HEADWEAR',
    abbreviation: 'HDWEAR',
    divisionCodes: ['30', '10']
  },
  {
    code: '80',
    description: 'GLOVE',
    abbreviation: 'GLOVE',
    divisionCodes: ['10', '30']
  },
  {
    code: '97',
    description: 'MISCELLANEOUS',
    abbreviation: 'MISC.',
    divisionCodes: ['10']
  },
  {
    code: '98',
    description: 'OTHER ACCESSOR.',
    abbreviation: 'ACCESS',
    divisionCodes: ['10', '30']
  },
  {
    code: '04',
    description: 'SOCK SHOE',
    abbreviation: 'SOCKSH',
    divisionCodes: ['20']
  },
  {
    code: '03',
    description: 'SANDAL',
    abbreviation: 'SANDAL',
    divisionCodes: ['20']
  },
  {
    code: '00',
    description: 'NOT APPLICABLE',
    abbreviation: 'N/A',
    divisionCodes: ['20', '40', '10', '30']
  },
  {
    code: '02',
    description: 'BOOT',
    abbreviation: 'BOOT',
    divisionCodes: ['20']
  },
  {
    code: '01',
    description: 'SHOE',
    abbreviation: 'SHOE',
    divisionCodes: ['20']
  },
  {
    code: '07',
    description: 'GOLF CLUB',
    abbreviation: 'GLFCLB',
    divisionCodes: ['30']
  },
  {
    code: '09',
    description: 'OTHR CLUB ACESS',
    abbreviation: 'OTCLAC',
    divisionCodes: ['30']
  },
  {
    code: '08',
    description: 'CLUB COMPONENT',
    abbreviation: 'CLBCPT',
    divisionCodes: ['30']
  },
  {
    code: '06',
    description: 'EYEWEAR',
    abbreviation: 'EYWEAR',
    divisionCodes: ['30']
  },
  {
    code: '81',
    description: 'TIGHT',
    abbreviation: 'TIGHT',
    divisionCodes: ['10']
  },
  {
    code: '83',
    description: 'SHORTS',
    abbreviation: 'SHORTS',
    divisionCodes: ['10']
  },
  {
    code: '677',
    description: 'ADJUSTABLE CAP',
    abbreviation: 'ADJCAP',
    divisionCodes: ['10']
  },
  {
    code: '676',
    description: 'BEANIE',
    abbreviation: 'BEANIE',
    divisionCodes: ['10']
  },
  {
    code: '680',
    description: 'BUCKET HAT',
    abbreviation: 'BUCHAT',
    divisionCodes: ['10']
  },
  {
    code: '693',
    description: 'UPPER SHORT W UPP TGH TGT',
    abbreviation: 'USHWUT',
    divisionCodes: ['10']
  },
  {
    code: '678',
    description: 'VISOR',
    abbreviation: 'VISOR',
    divisionCodes: ['10']
  },
  {
    code: '679',
    description: 'FITTED CAP',
    abbreviation: 'FITCAP',
    divisionCodes: ['10']
  },
  {
    code: '692',
    description: 'UPPER SHORT W MID TGH TGT',
    abbreviation: 'USHWMT',
    divisionCodes: ['10']
  },
  {
    code: '689',
    description: 'MID SHORT W MID TGH TGT',
    abbreviation: 'MSHWMT',
    divisionCodes: ['10']
  },
  {
    code: '681',
    description: 'CALF SKIRT W UPP SHORT',
    abbreviation: 'CFSWUS',
    divisionCodes: ['10']
  },
  {
    code: '690',
    description: 'MID SKIRT W MID SHORT',
    abbreviation: 'MSWMSH',
    divisionCodes: ['10']
  },
  {
    code: '688',
    description: 'MID SHORT W KNEE TGT',
    abbreviation: 'MSHWKT',
    divisionCodes: ['10']
  },
  {
    code: '685',
    description: 'KNEE SHORT W KNEE TGT',
    abbreviation: 'KSHWKT',
    divisionCodes: ['10']
  },
  {
    code: '695',
    description: 'UPPER SKIRT W UPP SHORT',
    abbreviation: 'USWUSH',
    divisionCodes: ['10']
  },
  {
    code: '691',
    description: 'UPPER SHORT W KNEE TGT',
    abbreviation: 'USHWKT',
    divisionCodes: ['10']
  },
  {
    code: '707',
    description: 'WAIST LENGTH JKT'
  },
  {
    code: '708',
    description: 'WAIST LENGTH HOODED JKT'
  },
  {
    code: '709',
    description: 'HIP LENGTH JKT'
  },
  {
    code: '710',
    description: 'HIP LENGTH HOODED JKT'
  },
  {
    code: '711',
    description: 'THIGH LENGTH JKT'
  },
  {
    code: '712',
    description: 'THIGH LENGTH HOODED JKT'
  },
  {
    code: '713',
    description: 'FULL LENGTH JKT'
  },
  {
    code: '714',
    description: 'FULL LENGTH HOODED JKT'
  },
  {
    code: '715',
    description: 'WAIST LENGTH VEST'
  },
  {
    code: '716',
    description: 'WAIST LENGTH HOODED VEST'
  },
  {
    code: '717',
    description: 'HIP LENGTH VEST'
  },
  {
    code: '718',
    description: 'HIP LENGTH HOODED VEST'
  },
  {
    code: '719',
    description: 'THIGH LENGTH VEST'
  },
  {
    code: '720',
    description: 'THIGH LENGTH HOODED VES'
  }
];

export const mapSilhouetteList = list =>
  list.map(({ unitAttributeName, unitAttributeValue }) => {
    const silhouetteList = unitAttributeName === 'SIL' ? silhouettes : silhouetteTypes;
    const currSilhouette = silhouetteList.filter(sil => sil.code === unitAttributeValue)[0];
    return currSilhouette || null;
  });

export const mapSilhouette = ({ unitAttributeName, unitAttributeValue }) => {
  if (unitAttributeName === 'DIV' && unitAttributeValue === '20') {
    return 'FOOTWEAR';
  }
  if (unitAttributeName === 'DIV' && unitAttributeValue === '10') {
    return 'APPAREL';
  }
  if (unitAttributeName === 'DIV' && unitAttributeValue === '30') {
    return 'EQUIPMENT';
  }
  const silhouetteList = unitAttributeName === 'SIL' ? silhouettes : silhouetteTypes;
  const currSilhouette = silhouetteList.filter(sil => sil.code === unitAttributeValue)[0];
  return currSilhouette ? currSilhouette.description : null;
};

export const splitUnitTypes = productList =>
  productList.reduce((total, prod) => {
    const updatedTotal = total;
    prod.metaData.unitAllotments.forEach(allot => {
      const name = mapSilhouette(allot);
      if (updatedTotal[name]) {
        updatedTotal[name] = { ...updatedTotal[name], totalQty: updatedTotal[name].totalQty + prod.totalUnits };
      } else {
        updatedTotal[name] = {
          totalQty: prod.totalUnits,
          allotmentAmount: allot.allotmentAmount,
          totalSpend: allot.totalSpend
        };
      }
    });
    return updatedTotal;
  }, {});
